<template>
  <div class="mb-8">
    <v-card class="mx-auto mb-3">
      <div id="filters">
        <template>
          <v-toolbar flat>
            <v-toolbar-title>
              <p class="mb-0">{{ $t("MANAGE_STUDENTS_DATA") }}</p>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="90vh">
              <v-card outlined>
                <v-form ref="editForm" v-model="valid" lazy-validation>
                  <v-card-title class="justify-center">
                      <span class="headline white--text text-thin">{{
                          formTitle
                        }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-alert v-show="showAlert" dense outlined type="error">{{
                          serverTranslate(errorMessages)
                        }}
                      </v-alert>
                      <v-row>
                        <v-col cols="12">
                          <pr-scope key="componentKey" :scopeFullPath="true"/>
                        </v-col>
                        <v-text-field
                            ref="nID"
                            v-model="editedStudentItem.nId"
                            :counter="14"
                            :label="$t('NID')"
                            :maxlength="14"
                            :rules="NIDRulse"
                            append-icon="mdi-card-account-details-outline"
                            color="primary"
                            dense
                            outlined
                            required
                            @keydown.space="preventLeadingSpace"
                        ></v-text-field>
                        <v-text-field
                            ref="email"
                            v-model="editedStudentItem.email"
                            :label="$t('EMAIL')"
                            :rules="emailRules"
                            append-icon="mdi-at"
                            color="primary"
                            dense
                            outlined
                            required
                            @keydown.space="preventLeadingSpace"
                        ></v-text-field>

                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark @click="save()">{{
                        $t("SAVE")
                      }}
                    </v-btn>

                    <v-btn class="white--text" color="darken3" @click="close">{{
                        $t("CANCEL")
                      }}
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-toolbar>


          <v-form ref="form">
            <v-container>
              <v-row>
                <v-col class="pa-0 my-0" cols="12" lg="12" md="12" sm="12" xs="12">
                  <v-radio-group v-model="searchWithId" class="ma-0" row>
                    <v-radio :label="$t('STUDENT_NAME')" value="1"></v-radio>
                    <v-radio :label="$t('IDENTITY')" value="2"></v-radio>
                  </v-radio-group>
                </v-col>

                <v-col v-if="searchWithId==='2'" class="py-0" cols="12" lg="12" md="12" sm="12" xs="12">
                  <v-text-field
                      v-model="identityNum"
                      :label="$t('WithIDENTITYTEXT')"
                      :rules="$store.state.Rules.noSpecialLetter"
                      counter="25"
                      outlined
                  ></v-text-field>
                </v-col>

                <v-col v-if="searchWithId==='3'"
                       class="py-0" cols="12" lg="12" md="12" sm="12" xs="12">
                  <v-text-field
                      v-model="appId"
                      :label="$t('WITHAPPID')"
                      :rules="$store.state.Rules.noSpecialLetter"
                      counter="25"
                      outlined
                  ></v-text-field>
                </v-col>


                <v-col v-if="searchWithId==='1'"
                       class="py-0"
                       cols="12" lg="12" md="12" sm="12" xs="12">
                  <v-autocomplete
                      v-model="studentId"
                      :items="students"
                      :label="$t('WithNAMETEXT')"
                      :loading="searchIsLoading"
                      :search-input.sync="studentSearch"
                      clearable
                      item-text="name"
                      item-value="id"
                      no-filter
                      outlined
                      return-object
                  ></v-autocomplete>
                </v-col>

              </v-row>
              <v-card-actions class="pa-0">
                <v-container class="px-0">
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-col class="pa-1" cols="auto">
                      <v-btn color="primary" dark @click="searchStudents">
                        {{ $t("SEARCH") }}
                      </v-btn>

                    </v-col>
                    <v-col class="pa-1 mx-2" cols="auto">
                      <v-btn
                          class="white--text"
                          color="darken3"
                          @click="reset"
                      >
                        {{ $t("RESET") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-actions>
            </v-container>
          </v-form>

           <!-- Alert Dialog -->
    <v-dialog v-model="alertDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline">{{ alertTitle }}</v-card-title>
        <v-card-text>{{ alertMessage }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="alertDialog = false">{{$t('CANCEL')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


        </template>
      </div>
    </v-card>
    <v-card class="mx-auto" outlined>
      <div id="inspire">

        <v-data-table
            :footer-props="{
               showFirstLastPage: true,
               firstIcon: 'mdi-arrow-collapse-left',
               lastIcon: 'mdi-arrow-collapse-right',
               prevIcon: 'mdi-arrow-left',
               nextIcon: 'mdi-arrow-right',
               itemsPerPageOptions: [5, 10, 15, 50, 100]
               }"
            :headers="headers"
            :hide-default-footer="studentsData.length > 0 ? false : true"
            :items="studentsData"
            :items-per-page="5"
            :loading="loading"
            :options.sync="appOptions"
            :server-items-length="total"
            class="elevation-1 pointer"
        >
          <template v-slot:item.studentName="{ item }">
            {{ serverTranslate(item.studentName) }}
          </template>

          <template v-slot:item.accountStatus="{ item }">
            {{
              item.accountStatus == true ? $t("ACTIVE") : $t("NOT_ACTIVE")
            }}
          </template>

          <template v-slot:no-data>
            <v-alert class="mt-2" color="light5" icon="warning">
              {{ $t("NO_DATA") }}
            </v-alert>
          </template>
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title> {{ title }}</v-toolbar-title>
            </v-toolbar>
          </template>
          <template v-slot:footer.page-text="props">
            {{ props.pageStart }} - {{ props.pageStop }} {{ $t('PAGE_TEXT') }} {{ props.itemsLength }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip
                v-if="canEditStudentData"
                bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon color="primary" meduim @click="editStudentData(item)"
                  >mdi-pencil
                  </v-icon
                  >
                </v-btn>
              </template>
              <span>{{ $t("EDIT") }}</span>
            </v-tooltip>

            <v-tooltip
                v-if="canPullGSDeleteStudentData"
                bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon
                      class="mx-2"
                      color="delete"
                      meduim
                      @click="deleteUser(item)"
                  >mdi-delete
                  </v-icon
                  >
                </v-btn>
              </template>
              <span>{{ $t("DELETE") }}</span>
            </v-tooltip>

            <v-tooltip
                v-if="canPullGSDeleteStudentData"
                bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon
                      class="mx-2"
                      color="primary"
                      medium
                      @click="pullGS(item)"
                  >
                    mdi-database-arrow-down
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("BUTTONS.PULL_GS_DATA") }}</span>
            </v-tooltip>

          </template>

        </v-data-table>
      </div>
    </v-card>
    <ad-confirmDialog ref="confirm"></ad-confirmDialog>
    <pr-ApplicationDetails/>
    <pr-scope v-if="showScopeTree == true" :key="componentKey" :scopeFullPath="false" v-on:setScope="onScopeChanged"/>
    <pr-confirmDialog ref="confirm"></pr-confirmDialog>
  </div>
</template>

<script>
import serverTranslations from "@/mixins/serverTranslations";
import ShowApplicationDetails from "@/components/modules/studentData/ManageApplications/ShowApplicationDetails";
import scope from "@/components/shared/ScopeTree.vue"
import {EventBus} from "@/plugins/bus";
import ConfirmDialog from "@/components/shared/ConfirmDialog.vue";
import globalMethodsMixin from "@/mixins/globalMethods.ts";

export default {
  name: "List",
  components: {
    "ad-confirmDialog": ConfirmDialog,
    "pr-scope": scope,
    "pr-ApplicationDetails": ShowApplicationDetails,
    "pr-confirmDialog": ConfirmDialog
  },
  mixins: [serverTranslations, globalMethodsMixin],

  mounted() {
    this.searchStudents(true);
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const mv = this;
    EventBus.$on("updateRunListAfterAction", () => {
      mv.searchStudents();
    });
  },
  watch: {
    searchWithId() {
      this.studentId = null;
      this.students = [];
      this.studentSearch = "";
      this.identityNum = "";
    },
    appOptions: {
      handler() {
        this.searchStudents();
      },
      deep: true,
    },
    studentSearch(val) {
      if (!val || val.length < 3) {
        this.students = [];
        return false;
      }
      if (this.searchIsLoading) return;
      const phraseLang = this.isRTL(val) ? "ar" : "en"
      const data = {searchData: val}
      this.searchIsLoading = true;
      this.$http.post("/api/students_admission_apps/search_student_user/", data)
          .then(
              res => {
                res = res.data.data;
                this.students = res.students.map(item => {
                  return {"id": item.studentId, "name": this.serverTranslateCustom(item.studentName, phraseLang)}
                });
              },
              err => {
                this.showToasted("error", err.response.data.message)
              }
          )
          .then(() => (this.searchIsLoading = false));

    },
  },
  computed: {
    canPullGSDeleteStudentData() {
      return this.$store.getters.hasPermission("students_admission_apps.can_pull_GS_delete_stu_user");
    },
    canEditStudentData() {
      return this.$store.getters.hasPermission("students_admission_apps.can_edit_stu_user");
    },
    formTitle() {
      return this.$t("EDIT_STUDENT_DATA");
    },
    isSearchedWithName() {
      return this.searchWithId === "1";
    },
    isSearchedWithAppId() {
      return this.searchWithId === "3";
    },
    title() {
      return this.$t('USERS_LIST_TITLE',);
    },
    headers() {
      return [
        {
          text: this.$t("STUDENT_NAME"),
          align: "center",
          sortable: true,
          value: "studentName"
        },
        {
          text: this.$t("IDENTITY"),
          align: "center",
          sortable: false,
          value: "identityNum"
        },
        {
          text: this.$t("EMAIL"),
          align: "center",
          sortable: false,
          value: "studentEmail"
        },
        {
          text: this.$t("ACCOUNT_STATUS"),
          align: "center",
          sortable: false,
          value: "accountStatus"
        },

        {
          text: this.$t("APPLICATIONS_COUNT"),
          align: "center",
          sortable: true,
          value: "appCount"
        },
        {
          text: this.$t("USER_NAME"),
          align: "center",
          sortable: true,
          value: "userName"
        },
        (this.canPullGSDeleteStudentData || this.canEditStudentData ? {
          text: this.$t("ACTIONS"),
          value: "actions",
          sortable: false
        } : '')

      ];
    }
  },
  data() {
    return {
      alertDialog: false,
      alertTitle: "تنبيه",
      alertMessage: "",
      NIDRulse: this.$store.state.Rules.NIDRulse,
      emailRules: this.$store.state.Rules.emailRules,
      requiredRules: this.$store.state.Rules.requiredRules,
      editedStudentItem: {
        stuId: "",
        nId: "",
        email: "",
      },
      currentItem: {
        stuId: "",
        nId: "",
        email: "",
      },
      errorMessages: "",
      showAlert: false,
      dialog: false,
      valid: true,
      loading: false,
      scopes: [],
      studentSearch: "",
      searchWithId: "1",
      searchWithAppId: "1",
      searchIsLoading: false,
      students: [],
      studentsData: [],
      identityNum: "",
      appId: "",
      total: 0,
      appOptions: {},
      studentId: "",
      showScopeTree: false,
      componentKey: 0
    };
  },
  methods: {
    showAlertDialogue(message, title = "تنبيه") {
      this.alertMessage = this.serverTranslate(message)
      this.alertTitle = title;
      this.alertDialog = true;
    },
    async pullGS(item) {
      if (!item.identityNum || !item.prequalYearName) {
        this.showAlertDialogue('لا يمكن السحب لا يوجد بيانات مؤهل سابق للطالب |student not having prequal data ');
        return false
      }
      else {
        // confirm message with translation
      const pullConfirm = this.$t("CONFIRM_MESSAGES.PULL_SECONDARY_DATA", {
        studentName: this.serverTranslate(item.studentName),
        cardId: item.identityNum,
      });

      // open dialog and wait for result
      const confirm = await this.$refs.confirm.open(
          "CONFIRMATION_MESSAGE",
          pullConfirm
      );

      if (confirm) {
        try {
          const pullRetData = await this.pullSecondaryData(
              this.$http,
              item.identityNum,
              item.prequalYearName
          );
          if (pullRetData.status === 200) {
            const pulledData=pullRetData.data.data
            const msg = `تم سحب الطالب / ${pulledData.name}
                      مجموع: ${pulledData.total} - ${this.serverTranslate(pulledData.secondaryName)} - تخصص / ${pulledData.majorName}`;
            this.$toasted.show(msg, {
              type: "success",
              icon: "check_circle",
              duration: 6000,
              position: "bottom-center"
            });
            this.close();
          } else {
            this.showToasted("error", pullRetData.message || "فشل السحب");
          }
        } catch (err) {
          this.showToasted("error", "فشل فى سحب بيانات الطالب يرجى مراجعة الرقم القومى وعام الحصول على المؤهل ");
          console.error(err);
        }
      }
      }


    }
    ,
    close() {
      this.$refs.form.resetValidation();
      this.dialog = false;
      this.showAlert = false;
      this.errorMessages = "";
    },

    save() {
      if (this.currentItem.nId === this.editedStudentItem.nId && this.currentItem.email === this.editedStudentItem.email) {
        this.errorMessages = 'لا يوجد اى تعديل |no update found';
        this.showAlert = true;
      } else {
        if (this.$refs.editForm.validate()) {
          this.errorMessages = '';
          this.showAlert = false;
          this.updateStudentData();
        }
      }

    },

    updateStudentData() {
      const stuData = {'editedData': this.editedStudentItem, 'oldData': this.currentItem}
      this.$http.put(
          "/api/students_admission_apps/edit_student_user_data/",
          stuData
      ).then(
          res => {
            this.showToasted("success", res.data.message);
            this.close();
            this.searchStudents(true);
          },
          err => {
            this.errorMessages = err.response.data.message;
            this.showAlert = true;
            this.searchStudents(true);
          }
      );
    },

    editStudentData(studentItem) {
      this.dialog = true;
      this.editedStudentItem.nId = studentItem.identityNum
      this.editedStudentItem.stuId = studentItem.studentId
      this.editedStudentItem.email = studentItem.studentEmail
      this.currentItem.nId = studentItem.identityNum
      this.currentItem.stuId = studentItem.studentId
      this.currentItem.email = studentItem.studentEmail

    },

    deleteUser(item) {
      this.$refs.confirm
          .open("CONFIRMATION_MESSAGE", "CONFIRM_MESSAGES.DELETE_CONFIRMATION")
          .then(confirm => {
            if (confirm) {
              const id = {studentId: JSON.stringify(item.studentId)};
              this.$http.delete(`/api/students_admission_apps/delete_student_user/${JSON.stringify(item.studentId)}`).then(
                  res => {
                    this.showToasted("success", res.data.message)
                    this.initializeList()
                        .then(data => {
                          this.studentsData = data.items;
                          this.total = data.total;
                        });
                  },
                  err => {
                    this.showToasted("error", err.response.data.message)
                    if (err.response.status === 404) {
                      this.initializeList()
                          .then(data => {
                            this.studentsData = data.items;
                            this.total = data.total;
                          });
                    }
                  }
              );
            }
          });

    },

    showScopeTreeFn() {
      this.showScopeTree = true;
      this.componentKey += 1;
    },

    initializeList() {
      return new Promise((resolve, reject) => {
        const data = this.searchedData();
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.$http
              .post("/api/students_admission_apps/list_student_users/", data)
              .then(
                  res => {
                    this.studentsData = [];
                    const items = res.data.data.results;
                    const total = res.data.data.total;
                    resolve({
                      items,
                      total,
                    });
                  },
                  err => {
                    this.studentsData = [];
                    this.$toasted.show(this.serverTranslate(err.response.data.message),
                        {
                          type: "error",
                          icon: "error_outline",
                          position: "bottom-left",
                          duration: 5000,
                          theme: "bubble"
                        }
                    );
                  }
              );
          this.loading = false;
        }, 1000);
      });
    },
    searchedData() {
      this.loading = true;
      const {sortBy, sortDesc, page, itemsPerPage} = this.appOptions
      const data = {
        studentId: !this.studentId || !this.studentId.id ? "" : this.studentId.id,
        identityType: this.searchWithId || "",
        searchText: this.identityNum || this.appId || "",
        page: page,
        pageSize: itemsPerPage
      }
      if (sortBy.length === 1 && sortDesc.length === 1) {
        data.orderType = sortDesc[0] ? "asc" : "desc";
        data.orderBy = sortBy[0]
      }
      return data
    },

    searchStudents(resetPageNum = false) {
      if (resetPageNum) {
        this.appOptions.page = 1;
        this.appOptions.sortBy = [];
        this.appOptions.sortDesc = [];
      }
      this.initializeList()
          .then(data => {
            this.studentsData = data.items;
            this.total = data.total;
          });
    },

    reset() {
      this.studentId = null;
      this.students = [];
      this.identityNum = "";
      this.searchWithId = "1";
      this.studentSearch = "";
      this.searchStudents(true);
    },
    onScopeChanged(changed) {
      if (changed)
        this.searchStudents(true);
    },
  }
};
</script>
